import React from "react";

import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight } from "react-icons/hi";
import { AboutUsBg, OurSolIcon, service_7, service_8 } from "../../assets/img";

import "./aboutUs.css";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AboutUs = ({ title, description, image }) => {
	const navigate = useNavigate();

	const { t, i18n } = useTranslation();

	return (
		<section className=' pt-16 pb-16 relative  md:px-12 px-4  '>
			<div className='flex md:flex-row flex-col-reverse justify-start items-center lg:gap-28 md:gap-20 sm:gap-10 gap-0'>
				<div className='md:w-[50%] w-full text-start'>
					<div className='flex  md:justify-start justify-center  items-center gap-2 mb-4'>
						<img
							loading='lazy'
							className='rotate-animate'
							src={OurSolIcon}
							alt=''
						/>
						<h3 className=' text-second_color font-semibold md:text-4xl text-3xl'>
							{title}
						</h3>
					</div>
					<Fade direction='down' triggerOnce='true' className='mb-4'>
						<div className=' mb-4'>
							<h3
								className={`${
									i18n?.language === "en"
										? "about-rag-title-ltr"
										: "about-rag-title-rtl"
								} about-rag-title relative mb-8 text-main_color font-medium text-2xl`}>
								<span className=' rag-bg relative font-sans '>RAJ</span>{" "}
								{t("raj in lines")}
							</h3>
						</div>
					</Fade>

					<div className='about-image-box md:w-[50%] w-full md:hidden flex mb-10 '>
						<Fade direction='left' triggerOnce='true'>
							<img
								loading='lazy'
								className='w-[90%] relative'
								src={image}
								alt=''
							/>
						</Fade>
					</div>

					<div>
						<Fade
							direction={`${i18n?.language === "ar" ? "right" : "left"}`}
							triggerOnce='true'>
							<h4 className='md:text-xl text-lg text-main_color  md:font-normal font-normal  mb-2'>
								{description}
							</h4>
						</Fade>

						<div className='grid grid-cols-2  gap-3 mb-6'>
							<div className=' hover:border-second_color shadow-xl hover:shadow-2xl custom-shadow custom-transition flex md:flex-row flex-col  md:justify-start justify-center items-center gap-3 rounded-md  border-[1px] border-slate-300 md:py-5 py-3 md:px-6 px-2'>
								<img loading='lazy' src={service_7} alt='' />
								<div>
									<h2 className='text-2xl text-main_color md:text-start text-center  font-semibold'>
										+29
									</h2>
									<p className='text-xl text-semi_second_color font-normal'>
										{t("about years")}
									</p>
								</div>
							</div>

							<div className=' hover:border-second_color shadow-xl hover:shadow-2xl custom-transition  flex md:flex-row flex-col md:justify-start justify-center items-center  gap-3 rounded-md  border-[1px] border-slate-300 py-3 md:px-6 px-2'>
								<img loading='lazy' src={service_8} alt='' />
								<div>
									<h2 className='text-2xl text-main_color md:text-start text-center  font-semibold'>
										+45
									</h2>
									<p className='text-xl text-semi_second_color font-normal'>
										{t("about teams")}
									</p>
								</div>
							</div>
						</div>

						<Fade
							direction={`${i18n?.language === "ar" ? "right" : "left"}`}
							triggerOnce='true'
							className='z-10 relative inline-block'>
							<button
								onClick={() => navigate("/about_us")}
								className={`${
									i18n?.language === "en"
										? "default-btn-ltr"
										: "default-btn-rtl"
								} default-btn md:inline-block flex m-auto  `}>
								{t("more about raj")}

								{i18n?.language === "ar" ? (
									<HiOutlineArrowSmLeft className='rtl' />
								) : (
									<HiOutlineArrowSmRight className='ltr' />
								)}

								<span></span>
							</button>
						</Fade>
					</div>
				</div>
				<div className='about-image-box md:w-[50%] w-full md:flex hidden'>
					<Fade direction='left' triggerOnce='true'>
						<img
							loading='lazy'
							className='w-[75%] relative'
							src={image}
							alt=''
						/>
					</Fade>
				</div>
			</div>

			<div
				className={`${
					i18n?.language === "en" ? "circle-shape1-ltr" : "circle-shape1-rtl"
				} circle-shape1`}>
				<img loading='lazy' className='w-1/2' src={AboutUsBg} alt='' />
			</div>
		</section>
	);
};

export default AboutUs;
